import { DEFAULT_LOGO_IMAGE, SITE_NAME } from "../lib/site";

const BrandLogo = ({
  className = "h-10 w-10",
  alt = `${SITE_NAME} logo`,
  rounded = "rounded-xl",
  padded = false,
}) => {
  const paddingClass = padded ? "p-1.5" : "";

  return (
    <img
      src={DEFAULT_LOGO_IMAGE}
      alt={alt}
      className={`${className} ${rounded} ${paddingClass} object-contain`}
      loading="eager"
      decoding="async"
    />
  );
};

export default BrandLogo;
